<template>
	<div class="main-container">
		<input :accept="accepted" @change="fileChange" class="file-input" multiple ref="fileInput" type="file"/>
		<label class="main-label">{{$props.label}}</label>
		<v-tooltip bottom v-if="!uploadInProgress && !readonly">
			<v-btn @click="uploadClick" icon slot="activator">
				<v-icon small>fa-upload</v-icon>
			</v-btn>
			<span>{{$t('tooltips.uploadFile')}}</span>
		</v-tooltip>
		<div v-if="uploadInProgress">
			{{$t('labels.uploadInProgress')}}
		</div>
		<div class="files-container" v-cloak @drop.prevent="dropFiles" @dragover.prevent>
			<div :key="key" v-for="(file, key) in files" class="file-container">
				<v-tooltip bottom>
					<v-icon v-if="!readonly" @click="removeFileClick(key)" small slot="activator">fa-trash</v-icon>
					<span>{{$t('tooltips.removeFile')}}</span>
				</v-tooltip>
				&nbsp;&nbsp;<span class="file-link" @click="openFileClick(file)" target="_blank">{{ file.original_name }}</span>
			</div>
			<div v-if="!readonly" class="files-drop"><v-icon small>fas fa-copy</v-icon> {{ $t('labels.dragdrop') }}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "UploadMultiple",
		props: ['value', 'accept', 'label', 'readonly', 'max'],
		components: {},
		data() {
			return {
				files: [],
				accepted: '',
				uploadInProgress: false
			};
		},
		watch: {
			value: function () {
				this.files = this.$props.value;
			}
		},
		methods: {
			dropFiles(dropped){
				if (!this.readonly) {
					this.uploadFiles(dropped.dataTransfer.files);
				}
			},
			callChange() {
				this.$emit('changes');
			},
			removeFileClick(key) {
				var vm = this;
				this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
					if (result) {
						vm.files.splice(key, 1);
						vm.callChange();
					}
				});
			},
			uploadClick() {
				this.$refs.fileInput.click();
			},
			fileChange() {
				this.uploadFiles(this.$refs.fileInput.files);
			},
			uploadFiles(files) {
				let countOk = true;
				if (this.max !== undefined) {
					if (this.files.length + files.length >= this.max) {
						countOk = false;
					}
				}
				if (countOk) {
					let vm = this;
					for (let fileKey = 0; fileKey < files.length; fileKey++) {
						this.$myStore.commit('increaseLoaderCount');
						let file = files[fileKey];
						if (file.size <= 15 * 1024 * 1024) {
							vm.$APIUpload(file, data => {
								if (data['success']) {
									vm.files.push(data.file);
									vm.$myStore.commit('decreaseLoaderCount');
									vm.$nextTick(() => {
										if (vm.$myStore.state.loaderCount <= 0) {
											vm.callChange();
										}
									})
								}
							});
						} else {
							this.$myStore.commit('decreaseLoaderCount');
							this.$alert(this.$t('alerts.fileSizeMultiple').replace('%filename%', file.name));
						}
					}
				} else {
					this.$alert(this.$t('alerts.maxFiles'));
				}
			},
			openFileClick(file) {
				window.open(file.link);
			}
		},
		mounted() {
			if (this.accept !== undefined) {
				this.accepted = this.accept;
			}
			this.files = this.$props.value;
		}
	}
</script>

<style scoped>
	.main-container {
		padding: 8px;
	}

	.main-label {
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		color: rgba(0, 0, 0, 0.54);
	}

	.file-input {
		display: none;
	}

	.files-container {
		border: 1px solid #d5d5d5;
		padding: 10px;
		overflow-x: hidden;
	}

	.file-container {
		white-space: nowrap;
	}

	.file-link {
		cursor: pointer;
	}

	.files-drop {
		width: 100%;
		height: 40px;
		text-align: center;
		line-height: 40px;
	}
</style>
